module.exports = __webpack_public_path__ + "img/daddy.c01117d8.jpg";